import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { FavoritesPage } from './FavoritesPage';
import { FeaturedPage } from './FeaturedPage';

export function FavoritesArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<FavoritesPage />} />
        <Route path="/featured" element={<FeaturedPage />} />
      </Routes>
    </ArcheLayout>
  );
}
